export const PUBLIC_PATHNAMES = new Set(['/login', '/oauth/consent']);
